import React, { useEffect, useMemo, useRef, useState } from 'react';

import alert from '../../helpers/alert';
import extractErrorMessage from '../../utils/extractErrorMessage';
import styles from './sheetSync.module.css';
import { getPriceList } from '../../api/prices';

const emptyTarget = (markId = '', year = '') => ({
  markId: markId ? String(markId) : '',
  modelId: '',
  year,
  complectationId: '',
  volume: '',
  wdId: '',
});

// ÐÑÐ¸Ð²ÑÐ·ÐºÐ° Ñ Ð±ÑÐºÐ° â Ð¿Ð¾Ð»Ñ ÑÐ¾ÑÐ¼Ñ. wdId 0 â Â«Ñ Ð¼Ð°ÑÐ¸Ð½Ñ Ð½Ðµ ÑÐºÐ°Ð·Ð°Ð½Â», ÑÑÐ¾ Ð¾ÑÐ´ÐµÐ»ÑÐ½Ð¾Ðµ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ, Ð½Ðµ Â«Ð»ÑÐ±Ð¾Ð¹Â»
export const toForm = (t) => ({
  markId: String(t.markId ?? ''),
  modelId: t.modelId != null ? String(t.modelId) : '',
  year: t.issueYear || '',
  complectationId: t.complectationId != null ? String(t.complectationId) : '',
  volume: t.engineVolume || '',
  wdId: t.wdId != null ? String(t.wdId) : '',
});

// ÐÐ¾Ð»Ñ ÑÐ¾ÑÐ¼Ñ â ÑÐµÐ»Ð¾ Ð¿ÑÐ¸Ð²ÑÐ·ÐºÐ¸ Ð´Ð»Ñ Ð±ÑÐºÐ°
export const toLink = (sheetKey, f) => ({
  sheetKey,
  modelId: Number(f.modelId),
  issueYear: f.year.trim() || null,
  complectationId: f.complectationId ? Number(f.complectationId) : null,
  engineVolume: f.volume.trim() || null,
  wdId: f.wdId === '' ? null : Number(f.wdId),
});

// Ð ÐµÐ´Ð°ÐºÑÐ¾Ñ Ð¿ÑÐ¸Ð²ÑÐ·ÐºÐ¸ ÑÑÑÐ¾ÐºÐ¸: Ð²ÑÐ±Ð¸ÑÐ°ÐµÑÑÑ Ð¿ÑÐ°Ð²Ð¸Ð»Ð¾ Ð¿ÑÐ¸ÐºÐ°Ð·Ð° (Ð¼Ð¾Ð´ÐµÐ»Ñ, Ð³Ð¾Ð´, ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ñ, Ð¾Ð±ÑÑÐ¼, Ð¿ÑÐ¸Ð²Ð¾Ð´).
// ÐÑÐ°Ð²Ð¸Ð» Ð¼Ð¾Ð¶ÐµÑ Ð±ÑÑÑ Ð½ÐµÑÐºÐ¾Ð»ÑÐºÐ¾ â Ð² ÐºÐ°ÑÐ°Ð»Ð¾Ð³Ðµ Ð±ÑÐ²Ð°ÑÑ Ð´Ð²Ð¾Ð¹Ð½Ð¸ÐºÐ¸ ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ð¸, Ð¸ ÑÐµÐ½Ð° Ð¸Ð· ÑÐ°Ð±Ð»Ð¸ÑÑ Ð½ÑÐ¶Ð½Ð° Ð¾Ð±Ð¾Ð¸Ð¼.
const LinkEditor = ({ sheetKey, problem, marks, initial, suggestedMarkId, busy, saveText, onSave, onCancel }) => {
  const guess = useMemo(() => {
    if (suggestedMarkId) return suggestedMarkId;
    const brand = (problem?.brand || '').toLowerCase();
    return marks.find((m) => brand.includes((m.mark || '').toLowerCase()))?.markId || '';
  }, [problem, marks, suggestedMarkId]);

  const [targets, setTargets] = useState(() =>
    initial?.length ? initial.map(toForm) : [emptyTarget(guess, problem?.year || '')]
  );
  const [dicts, setDicts] = useState({});
  const requested = useRef(new Set());

  const markKey = targets.map((t) => t.markId).join(',');
  useEffect(() => {
    [...new Set(targets.map((t) => t.markId).filter(Boolean))].forEach((id) => {
      if (requested.current.has(id)) return;
      requested.current.add(id);
      getPriceList(id)
        .then((res) => setDicts((prev) => ({ ...prev, [id]: res.data })))
        .catch((err) => alert.error(extractErrorMessage(err) || 'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð·Ð°Ð³ÑÑÐ·Ð¸ÑÑ ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸ÐºÐ¸ Ð¼Ð°ÑÐºÐ¸'));
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [markKey]);

  const set = (i, patch) => setTargets((prev) => prev.map((t, k) => (k === i ? { ...t, ...patch } : t)));
  const suffix = (i) => (targets.length > 1 ? ` ${i + 1}` : '');
  const ready = targets.every((t) => t.modelId);

  return (
    <div className={styles.editor}>
      <div className={styles.editorHelp}>
        Ð£ÐºÐ°Ð¶Ð¸ÑÐµ Ð¿ÑÐ°Ð²Ð¸Ð»Ð¾ Ð¿ÑÐ¸ÐºÐ°Ð·Ð°, Ðº ÐºÐ¾ÑÐ¾ÑÐ¾Ð¼Ñ Ð¾ÑÐ½Ð¾ÑÐ¸ÑÑÑ ÑÑÑÐ¾ÐºÐ° {sheetKey}. ÐÐ±ÑÑÐ¼ Ð¸ Ð¿ÑÐ¸Ð²Ð¾Ð´ Ð¾ÑÑÐ°Ð²ÑÑÐµ Ð¿ÑÑÑÑÐ¼Ð¸, ÐµÑÐ»Ð¸ Ð¿ÑÐ°Ð²Ð¸Ð»Ð¾
        Ð´ÐµÐ¹ÑÑÐ²ÑÐµÑ Ð½Ð° Ð»ÑÐ±Ð¾Ð¹ Ð¾Ð±ÑÑÐ¼ Ð¸ Ð¿ÑÐ¸Ð²Ð¾Ð´. ÐÑÐ¸Ð²ÑÐ·ÐºÐ° ÑÐ¾ÑÑÐ°Ð½ÑÐµÑÑÑ ÑÑÐ°Ð·Ñ, Ð¿Ð¾ ÐºÐ½Ð¾Ð¿ÐºÐµ Ð½Ð¸Ð¶Ðµ, ÑÐµÐ½Ñ Ð¾Ð½Ð° Ð½Ðµ Ð¼ÐµÐ½ÑÐµÑ.
      </div>
      {targets.map((t, i) => {
        const dict = dicts[t.markId];
        const trims = (dict?.complectations || []).filter((c) => String(c.modelId) === t.modelId);
        return (
          <div className={styles.editorRow} key={i}>
            <label>
              ÐÐ°ÑÐºÐ°
              <select
                aria-label={`ÐÐ°ÑÐºÐ° Ð¿ÑÐ¸Ð²ÑÐ·ÐºÐ¸${suffix(i)}`}
                value={t.markId}
                onChange={(e) => set(i, { markId: e.target.value, modelId: '', complectationId: '', wdId: '' })}
              >
                <option value="">â</option>
                {marks.map((m) => (
                  <option key={m.markId} value={m.markId}>
                    {m.mark}
                  </option>
                ))}
              </select>
            </label>
            <label>
              ÐÐ¾Ð´ÐµÐ»Ñ
              <select
                aria-label={`ÐÐ¾Ð´ÐµÐ»Ñ Ð¿ÑÐ¸Ð²ÑÐ·ÐºÐ¸${suffix(i)}`}
                value={t.modelId}
                onChange={(e) => set(i, { modelId: e.target.value, complectationId: '' })}
              >
                <option value="">â</option>
                {(dict?.models || []).map((m) => (
                  <option key={m.id} value={m.id}>
                    {m.name}
                  </option>
                ))}
              </select>
            </label>
            <label>
              ÐÐ¾Ð´ (Ð¿ÑÑÑÐ¾ â Ð»ÑÐ±Ð¾Ð¹)
              <input
                aria-label={`ÐÐ¾Ð´ Ð¿ÑÐ¸Ð²ÑÐ·ÐºÐ¸${suffix(i)}`}
                value={t.year}
                onChange={(e) => set(i, { year: e.target.value })}
              />
            </label>
            <label>
              ÐÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ñ
              <select
                aria-label={`ÐÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ñ Ð¿ÑÐ¸Ð²ÑÐ·ÐºÐ¸${suffix(i)}`}
                value={t.complectationId}
                onChange={(e) => set(i, { complectationId: e.target.value })}
              >
                <option value="">Ð²ÑÑ Ð¼Ð¾Ð´ÐµÐ»Ñ</option>
                {trims.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.title}
                  </option>
                ))}
              </select>
            </label>
            <label>
              ÐÐ±ÑÑÐ¼ (Ð¿ÑÑÑÐ¾ â Ð»ÑÐ±Ð¾Ð¹)
              <input
                aria-label={`ÐÐ±ÑÑÐ¼ Ð¿ÑÐ¸Ð²ÑÐ·ÐºÐ¸${suffix(i)}`}
                value={t.volume}
                onChange={(e) => set(i, { volume: e.target.value })}
              />
            </label>
            <label>
              ÐÑÐ¸Ð²Ð¾Ð´
              <select
                aria-label={`ÐÑÐ¸Ð²Ð¾Ð´ Ð¿ÑÐ¸Ð²ÑÐ·ÐºÐ¸${suffix(i)}`}
                value={t.wdId}
                onChange={(e) => set(i, { wdId: e.target.value })}
              >
                <option value="">Ð»ÑÐ±Ð¾Ð¹</option>
                <option value="0">Ð½Ðµ ÑÐºÐ°Ð·Ð°Ð½ Ñ Ð¼Ð°ÑÐ¸Ð½Ñ</option>
                {(dict?.wd || []).map((w) => (
                  <option key={w.id} value={w.id}>
                    {w.title}
                  </option>
                ))}
              </select>
            </label>
            {targets.length > 1 && (
              <button
                type="button"
                className={styles.mini}
                title="Ð£Ð±ÑÐ°ÑÑ ÑÑÐ¾ Ð¿ÑÐ°Ð²Ð¸Ð»Ð¾ Ð¸Ð· Ð¿ÑÐ¸Ð²ÑÐ·ÐºÐ¸"
                onClick={() => setTargets((prev) => prev.filter((_, k) => k !== i))}
              >
                Ð£Ð±ÑÐ°ÑÑ
              </button>
            )}
          </div>
        );
      })}
      <div className={styles.editorActions}>
        <button
          type="button"
          className={styles.mini}
          title="ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ ÐµÑÑ Ð¾Ð´Ð½Ð¾ Ð¿ÑÐ°Ð²Ð¸Ð»Ð¾: ÑÐ°Ðº Ð´ÐµÐ»Ð°ÑÑ, ÐºÐ¾Ð³Ð´Ð° Ð² ÐºÐ°ÑÐ°Ð»Ð¾Ð³Ðµ Ð´Ð²Ð° Ð¾Ð´Ð¸Ð½Ð°ÐºÐ¾Ð²ÑÑ Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ñ ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ð¸"
          onClick={() => setTargets((prev) => [...prev, emptyTarget(prev[prev.length - 1]?.markId, prev[prev.length - 1]?.year || '')])}
        >
          + ÐµÑÑ Ð¿ÑÐ°Ð²Ð¸Ð»Ð¾
        </button>
        <span className={styles.grow} />
        <button
          type="button"
          className={styles.miniPrimary}
          disabled={busy || !ready}
          title={ready ? 'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð¿ÑÐ¸Ð²ÑÐ·ÐºÑ ÑÐµÐ¹ÑÐ°Ñ' : 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¼Ð¾Ð´ÐµÐ»Ñ Ð² ÐºÐ°Ð¶Ð´Ð¾Ð¼ Ð¿ÑÐ°Ð²Ð¸Ð»Ðµ'}
          onClick={() => onSave(targets.map((t) => toLink(sheetKey, t)))}
        >
          {saveText || 'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð¿ÑÐ¸Ð²ÑÐ·ÐºÑ'}
        </button>
        <button type="button" className={styles.mini} onClick={onCancel}>
          ÐÑÐ¼ÐµÐ½Ð°
        </button>
      </div>
    </div>
  );
};

export default LinkEditor;
